import styled from 'styled-components';

export const DisabledBlueButton = styled.div`
  padding: 8px;
  border-radius: 4px;

  border: none;
  background-color: #85B3FE;
  color: #ffffff;

  font-weight: 600;
  font-family: 'Noto Sans', sans-serif;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
`;
